// extracted by mini-css-extract-plugin
export default {"blogview":"cbac7792c1bdd898dda0"};